import { Outlet } from "@tanstack/react-router";
import { Sidebar } from "./Sidebar";
import { useTheme } from "./ThemeProvider";
import { PageTransition } from "./PageTransition";
import { CommandPalette } from "./CommandPalette";
import { AmbientBackground } from "./AmbientBackground";
import { Breadcrumbs } from "./Breadcrumbs";
import { useState } from "react";
import { ProductDock } from "./ProductDock";

export function Layout() {
  const { theme } = useTheme();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleOpenPalette = () => {
    if ((window as any).openCommandPalette) {
      (window as any).openCommandPalette();
    }
  };

  return (
    <div
      style={{ colorScheme: theme === "dark" ? "dark" : "light" }}
      className="min-h-screen relative flex justify-center bg-(--background) text-(--foreground)"
    >
      <AmbientBackground />
      <CommandPalette />
      
      <ProductDock onOpenPalette={handleOpenPalette} />

      <div className="flex relative pt-28 md:pt-32 pb-8 z-10 w-full px-4">
        <Sidebar isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed(c => !c)} />
        <main className="flex-1 min-w-0 min-h-[calc(100vh-10rem)] transition-all duration-300 pr-4">
          <div className="w-full">
            <Breadcrumbs />
            <PageTransition>
              <Outlet />
            </PageTransition>
          </div>
        </main>
      </div>
    </div>
  );
}